export function shouldFetchInitialClientNutritionPlans(clientPlanStore) {
  if (!clientPlanStore) {
    return false;
  }

  return clientPlanStore.hasFetchedPlans !== true;
}
